export function clearToDateIfBeforeFrom(
    from: Date | null | undefined,
    to: Date | null | undefined
): Date | null | undefined {
    if (from && to && new Date(to) < new Date(from)) {
        return null;
    }

    return to;
}

export function syncFilterToDateAfterFromChange<T extends object>(
    filterData: T,
    fromKey: keyof T & string,
    toKey: keyof T & string
): void {
    const filter = filterData as Record<string, Date | null | undefined>;
    filter[toKey] = clearToDateIfBeforeFrom(filter[fromKey], filter[toKey]);
}
